import MoviesSlider from '../MoviesSlider'
import './index.css'

const PrimeVideo = props => {
  const {moviesList} = props
  return (
    <div className="prime-video-main">
      <img
        src="https://assets.ccbp.in/frontend/react-js/prime-video-img.png"
        className="prime-video-logo"
        alt="prime video"
      />
      <h1 className="prime-video-category-name">Action Movies</h1>
      <MoviesSlider
        movieList={moviesList.filter(
          eachMovie => eachMovie.categoryId === 'ACTION',
        )}
      />
      <h1 className="prime-video-category-name">Comedy Movies</h1>
      <MoviesSlider
        movieList={moviesList.filter(
          eachMovie => eachMovie.categoryId === 'COMEDY',
        )}
      />
    </div>
  )
}

export default PrimeVideo
